export default "__VITE_ASSET__a3cab2e9__"